import React, { useState } from "react";
import styles from "./FreeDeliveryCreationForm.module.scss";
import ComponentBackButton from "../../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";
import { Row, Col, Form } from "reactstrap";
import FormInput from "../../../../../common/AdminCommonComponents/FormInput/FormInput";
import DynamicButton from "../../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";

const FreeDeliveryCreationForm = ({ setIsOpen }) => {
    const [formData, setFormData] = useState({
        voucherName: "",
        usageLimit: "",
        targetAudience: "",
    });

    const applyToOptions = [
        { label: "Option 1", value: "option1" },
        { label: "Option 2", value: "option2" },
        { label: "Option 3", value: "option3" },
    ];

    const targetGroupsOptions = [
        { label: "Option 1", value: "option1" },
        { label: "Option 2", value: "option2" },
        { label: "Option 3", value: "option3" },
    ];

    const deliveryZoneOptions = [
        { label: "Option 1", value: "option1" },
        { label: "Option 2", value: "option2" },
        { label: "Option 3", value: "option3" },
    ];

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    return (
        <div className={styles.mainContainer}>
            <div className={styles.orderDetailWrapper}>
                <ComponentBackButton onClick={() => setIsOpen(false)} />

                <h4 className={styles.mainHeading}>
                    <span>Free Delivery Creation Form</span>
                </h4>

                <Form>
                    <Row className="g-0 align-items-end">
                        <Col lg={3} className="pe-lg-3">
                            <FormInput
                                label="Promotion Period"
                                type="date"
                                placeholder="Start Date"
                                id="startDate"
                                name="startDate"
                                value={formData.startDate}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col lg={3} className="pe-lg-3">
                            <FormInput
                                type="date"
                                placeholder="End Date"
                                id="endDate"
                                name="endDate"
                                value={formData.endDate}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Budget"
                                type="text"
                                placeholder="Define Budget"
                                id="budget"
                                name="budget"
                                value={formData.budget}
                                onChange={handleChange}
                            />
                        </Col>
                    </Row>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Minimum Purchase Requirement"
                                type="text"
                                placeholder="Add Minimum Purchase Requirement"
                                id="minPurchase"
                                name="minPurchase"
                                value={formData.minPurchase}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Maximum Uses"
                                type="text"
                                placeholder="Add Maximum Uses"
                                id="maxUses"
                                name="maxUses"
                                value={formData.maxUses}
                                onChange={handleChange}
                            />
                        </Col>
                    </Row>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Apply to"
                                type="select"
                                placeholder="Select Apply to Option"
                                id="applyTo"
                                name="applyTo"
                                value={formData.applyTo}
                                onChange={handleChange}
                                options={applyToOptions}
                            />
                        </Col>
                        <Col lg={6} className="ps-lg-3">
                            <FormInput
                                label="Target Groups"
                                type="select"
                                placeholder="Select Target Groups"
                                id="targetGroups"
                                name="targetGroups"
                                value={formData.targetGroups}
                                onChange={handleChange}
                                options={targetGroupsOptions}
                            />
                        </Col>
                    </Row>
                    <Row className="g-0">
                        <Col lg={6} className="pe-lg-3">
                            <FormInput
                                label="Delivery Zone"
                                type="select"
                                placeholder="Select Delivery Zone"
                                id="deliveryZone"
                                name="deliveryZone"
                                value={formData.deliveryZone}
                                onChange={handleChange}
                                options={deliveryZoneOptions}
                            />
                        </Col>
                    </Row>


                    <div className={styles.submitButton}>
                        <DynamicButton theme="blue">Submit</DynamicButton>
                    </div>

                </Form>
            </div>
        </div>
    );
};

export default FreeDeliveryCreationForm;